/* eslint-disable react-hooks/exhaustive-deps */
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { Dropdown } from 'react-bootstrap';
//import DropdownMenu from 'react-bootstrap/esm/DropdownMenu';
import fileDownload from 'js-file-download';
import qs from 'query-string';

import * as S from './style';
//import { DateRange } from 'react-date-range';
//import { pt } from 'date-fns/locale';
//import useDraggableScroll from 'use-draggable-scroll';
import HeaderUserButton from '../LogOut';

import Loading from '../../../../img/loading-roll.svg';
import ArrowDownWhite from '../../../../img/arrow_dropdown-white.svg';
//import ArrowDownDark from '../../../../img/arrow_dropdown-dark.svg';
//import NavigateNextGreen from '../../../../img/navigate_next-green.svg';
//import Pagination from '@material-ui/lab/Pagination';
import api from '../../../../services/api';
import loadingGif from '../../../../img/loading-gif.gif';

//import { X_FOWARD_HOST } from '../../../../utils/env';
import {
	ConciliacaoProps,
	//Pagamento,
	//Transacao,
} from '../../../../model/model';
//import { DebouncerInput } from '../input';
import { SingleDropdownCalendar } from '../CalendarContainer';
import search_not_found from '../../../../img/search_not_found.svg';

// const pageLimit = 40;

export default function Conciliacoes() {
	const [filtroDia, setFiltroDia] = useState('hoje');

	const [loading, setLoading] = useState(false);
	const [conciliacoes, setConciliacoes] = useState<ConciliacaoProps[]>([]);
	const [loadingExport, setLoadingExport] = useState(false);

	const [dateList, setDateList] = useState<string[]>([]);
	useEffect(() => {
		if (conciliacoes && conciliacoes.length > 0) {
			const data = [];
			data.push(conciliacoes[0].date);

			for (let i = 1; i < conciliacoes.length; i += 1) {
				if (conciliacoes[i].date !== conciliacoes[i - 1].date) {
				}

				const f = data.find((d) => d === conciliacoes[i].date);
				if (f === undefined) {
					data.push(conciliacoes[i].date);
				}
			}
			setDateList([...data]);
		} else {
			setDateList([]);
		}
	}, [conciliacoes]);

	const headerData = [
		{ dia: 'hoje' },
		{ dia: 'ontem' },
		{ dia: 'este mês' },
		//{ dia: 'personalizado', personalizado: true },
	];

	const [rangeHeader, setRangeHeader] = useState([
		{
			startDate: moment(moment().format('DD/MM/YYYY'), 'DD/MM/YYYY').toDate(),
			endDate: moment(moment().format('DD/MM/YYYY'), 'DD/MM/YYYY').toDate(),
			key: 'selection',
		},
	]);

	function handleRange(dia: string) {
		const p = [
			{
				dia: 'hoje',
				f: function () {
					setRangeHeader([
						{
							startDate: moment(
								moment().format('DD/MM/YYYY'),
								'DD/MM/YYYY'
							).toDate(),
							endDate: moment(
								moment().format('DD/MM/YYYY'),
								'DD/MM/YYYY'
							).toDate(),
							key: 'selection',
						},
					]);
				},
			},
			{
				dia: 'ontem',
				f: function () {
					setRangeHeader([
						{
							startDate: moment(
								moment().subtract(1, 'days').format('DD/MM/YYYY'),
								'DD/MM/YYYY'
							).toDate(),
							endDate: moment(
								moment().subtract(1, 'days').format('DD/MM/YYYY'),
								'DD/MM/YYYY'
							).toDate(),
							key: 'selection',
						},
					]);
				},
			},
			{
				dia: 'este mês',
				f: function () {
					setRangeHeader([
						{
							startDate: moment().startOf('month').toDate(),
							endDate: moment(
								moment().format('DD/MM/YYYY'),
								'DD/MM/YYYY'
							).toDate(),
							key: 'selection',
						},
					]);
				},
			},
			{ dia: 'personalizado', f: function () {} },
		];
		const item = p.find((d) => d.dia === dia);
		if (item) {
			item.f();
		}
	}

	async function getExtratos(tipo: string, conciliacao: any, setLoading: any) {
		setLoading(true);

		//console.log(tipo);
		//console.log(conciliacao);
		const id = conciliacao.conta.id;

		//console.log(conciliacao.conta);
		const ref = conciliacao.ref;
		//console.log(id);

		try {
			const response = await api.get(
				`/admin/conciliacao/extratos?conta_id=${id}&formato=${tipo}&ref=${ref}`
			);

			if (response.data && response.status === 200) {
				if (tipo === 'XML') {
					fileDownload(response.data, `conciliacao${ref}.${tipo}`);
					setLoading(false);
				} else {
					let idExt = conciliacao.id.toString();

					for (let i = idExt.length; i < 6; i++) {
						idExt = `0${idExt}`;
					}
					////console.log(idExt);

					fileDownload(
						response.data,
						`${tipo}-${conciliacao.conta.codigo}.${idExt}`
					);
					setLoading(false);
				}
			} else {
				alert('Falha no download');
				setLoading(false);
			}

			////console.log(blob)
		} catch (error: any) {
			alert('Erro na obtenção do documento');
			if (error && error.response && error.response.status === 401) {
				window.location.reload();
			}
			//console.log(error);
			setLoading(false);
		}
	}

	async function getConciliacoes(params = {}) {
		//var self = this;
		setLoading(true);
		////console.log('Iniciando');
		const di = moment(rangeHeader[0].startDate).format('YYYY-MM-DD');
		const df = moment(rangeHeader[0].endDate).format('YYYY-MM-DD');

		try {
			const response = await api.get(
				`/admin/conciliacao/json?data_inicial=${di}&data_final=${df}`,
				params
			);
			const { status, data } = response;
			////console.log(data);
			if (status === 200) {
				setConciliacoes(data.conciliacoes);
				//self.setState({ conciliacoes: data.conciliacoes });
				setLoading(false);
			} else {
				alert('Erro em pesqusiar as conciliações');
			}
		} catch (error: any) {
			if (error && error.response && error.response.status === 401) {
				window.location.reload();
			}
		}
	}

	useEffect(() => {
		getConciliacoes();
	}, [rangeHeader]);

	const months = [
		{ value: '01', name: 'Janeiro' },
		{ value: '02', name: 'Fevereiro' },
		{ value: '03', name: 'Março' },
		{ value: '04', name: 'Abril' },
		{ value: '05', name: 'Maio' },
		{ value: '06', name: 'Junho' },
		{ value: '07', name: 'Julho' },
		{ value: '08', name: 'Agosto' },
		{ value: '09', name: 'Setembro' },
		{ value: '10', name: 'Outubro' },
		{ value: '11', name: 'Novembro' },
		{ value: '12', name: 'Dezembro' },
	];

	function convertDate(d: string) {
		const split = d.split('/');
		const f = months.find((m) => m.value === split[1]);
		if (f) {
			return `${split[0]} de ${f.name} de ${split[2]}`;
		}
		return '-';
	}

	async function getRelatorio(formato: string) {
		// let qparams = Object.assign({}, params);
		setLoadingExport(true);

		const data_inicial = moment(rangeHeader[0].startDate).format(
			'DD/MM/YYYY'
		);
		const data_final = moment(rangeHeader[0].endDate).format('DD/MM/YYYY');

		//unidade:pontovenda.value,tipo:tipo.value,status:situation.value,
		let qsx = qs.stringify(
			Object.assign({ formato: formato, data_inicial, data_final, })
		);

		////console.log(qparams);
		//	//console.log(qsx);
		try {
			// await 	sleep(2000)

			const response = await api.get(
				`/admin/transacao/relatorio?${qsx}`,

				{
					responseType: 'blob',
					headers: { Accept: 'application/pdf' },
				}
			);


			const {data} = response;

			if(data){
				const startDate = moment(rangeHeader[0].startDate).format('DD-MM-YYYY');
				const endDate = moment(rangeHeader[0].endDate).format('DD-MM-YYYY');

				fileDownload(
					response.data,
					`pagamentos${startDate}_${endDate}.${formato}`
				);
			}
			
			setLoadingExport(false);

		


			/*	const response = await api.get('/admin/transacao/relatorio?' + qsx, {
				responseType: 'blob',
				headers: { Accept: 'application/pdf' },
			});*/
			//	//console.log(response);

			//	//console.log(response.data);

			/*if (response.data && response.status === 200) {
				if (formato === 'pdf') {
					//const url = URL.createObjectURL(response.data);
					//window.open(url);

					fileDownload(
						response.data,
						`relatorio${qparams.data_inicial}_${qparams.data_final}.${formato}`
					);
					setLoadDownload(false);

					/*const blob = new Blob([response.data], { type: 'application/pdf' });
					if (blob) {
						const url = URL.createObjectURL(blob);
						window.open(url);
					}
				} else {
					fileDownload(
						response.data,
						`relatorio${qparams.data_inicial}_${qparams.data_final}.${formato}`
					);
					setLoadDownload(false);
				}
			}*/
		} catch (error: any) {
			//alert('error: ' + error);
			if (error && error.response && error.response.status === 401) {
				window.location.reload();
			}
			setLoadingExport(false);
		}
	}

	return (
		<S.Container>
			<S.Header className='mr-30'>
				<S.HeaderContainer>
					<S.HeaderTitle>
						<span>Conciliações</span>
					</S.HeaderTitle>
					<div
						style={{
							display: 'flex',
							flexDirection: 'row',
							alignItems: 'center',
							paddingRight: 16,
						}}>
						{headerData.map((data) => {
							return (
								<S.HeaderButton
									key={data.dia}
									onClick={(e) => {
										e.preventDefault();
										setFiltroDia(data.dia);
										handleRange(data.dia);
									}}
									active={data.dia === filtroDia}>
									<p>{data.dia}</p>
								</S.HeaderButton>
							);
						})}
						<SingleDropdownCalendar
							item={filtroDia}
							setItem={setFiltroDia}
							range={rangeHeader}
							setRange={setRangeHeader}
						/>
{/*
						<Dropdown>
							<Dropdown.Toggle className='dropdown-none'>
								<S.HeaderExport>
									<span className='ExportDropdown'>
										{!loadingExport ? (
											'Exportar'
										) : (
											<img alt='loading' src={Loading} />
										)}
									</span>
									<img
										className='ExportArrowDown'
										alt=''
										src={ArrowDownWhite}
									/>
								</S.HeaderExport>
							</Dropdown.Toggle>
							<Dropdown.Menu>
								<S.ExportHeaderMenu>
									<div className='export_header_menu_title'>
										Exportar relatório
									</div>
									<Dropdown.Item
										onSelect={(e) => {
											//e.preventDefault();
											getRelatorio('pdf');
										}}>
										Baixar PDF
									</Dropdown.Item>
								</S.ExportHeaderMenu>
							</Dropdown.Menu>
						</Dropdown>*/}
					</div>
				</S.HeaderContainer>
				<HeaderUserButton />
			</S.Header>
			<S.Body className='mr-30'>
				<S.ConciliacoesContainer>
					{loading ? (
						<div>
							<S.TableContainer>
								<S.TableHeader>
									<S.Skeleton style={{ width: 200, height: 32 }} />
								</S.TableHeader>
								<S.Table>
									<S.THead>
										<tr>
											<S.Th>Conta</S.Th>
											<S.Th>Capturas</S.Th>
											<S.Th>Canceladas</S.Th>
											<S.Th>Pagas</S.Th>
											<S.Th>Chargebacks</S.Th>
											<S.Th>Download de arquivos</S.Th>
										</tr>
									</S.THead>
									<S.TBody>
										{/*pagamentos.map((p) => (
									<TRItem pagamento={p} />
								))*/}

										{loading ? (
											<S.BodyTR>
												<td>
													<S.Skeleton style={{ width: '100%', height: 32 }} />
												</td>
												<td>
													<S.Skeleton style={{ width: '100%', height: 32 }} />
												</td>
												<td>
													<S.Skeleton style={{ width: '100%', height: 32 }} />
												</td>
												<td>
													<S.Skeleton style={{ width: '100%', height: 32 }} />
												</td>
												<td>
													<S.Skeleton style={{ width: '100%', height: 32 }} />
												</td>
												<td>
													<S.Skeleton style={{ width: '100%', height: 32 }} />
												</td>
											</S.BodyTR>
										) : (
											conciliacoes.map((c) => {
												return (
													<ConciliacaoTR conc={c} getExtratos={getExtratos} />
												);
											})
										)}
									</S.TBody>
								</S.Table>
							</S.TableContainer>
						</div>
					) : dateList.length === 0 ? (
						<div>
							<S.TableContainer style={{ position: 'relative' }}>
								<S.Table>
									<S.THead>
										<tr>
											<S.Th>Conta</S.Th>
											<S.Th>Capturas</S.Th>
											<S.Th>Canceladas</S.Th>
											<S.Th>Pagas</S.Th>
											<S.Th>Chargebacks</S.Th>
											<S.Th>Download de arquivos</S.Th>
										</tr>
									</S.THead>
								</S.Table>

								<S.NotFoundContainer style={{ paddingTop: 40 }}>
									<img alt='nao encontrado' src={search_not_found} />
								</S.NotFoundContainer>
								<div className='pagination_container'>
									<div className='not_found_text'>
										{' '}
										Não existem resultados para a data selecionada{' '}
									</div>
								</div>
							</S.TableContainer>
						</div>
					) : (
						dateList.map((dl) => (
							<div>
								<S.TableContainer>
									<S.TableHeader>{convertDate(dl)}</S.TableHeader>
									<S.Table>
										<S.THead>
											<tr>
												<S.Th>Conta</S.Th>
												<S.Th>Capturas</S.Th>
												<S.Th>Canceladas</S.Th>
												<S.Th>Pagas</S.Th>
												<S.Th>Chargebacks</S.Th>
												<S.Th>Download de arquivos</S.Th>
											</tr>
										</S.THead>
										<S.TBody>
											{/*pagamentos.map((p) => (
									<TRItem pagamento={p} />
								))*/}

											{loading ? (
												<S.BodyTR>
													<td>
														<S.Skeleton style={{ width: '100%', height: 32 }} />
													</td>
													<td>
														<S.Skeleton style={{ width: '100%', height: 32 }} />
													</td>
													<td>
														<S.Skeleton style={{ width: '100%', height: 32 }} />
													</td>
													<td>
														<S.Skeleton style={{ width: '100%', height: 32 }} />
													</td>
													<td>
														<S.Skeleton style={{ width: '100%', height: 32 }} />
													</td>
													<td>
														<S.Skeleton style={{ width: '100%', height: 32 }} />
													</td>
												</S.BodyTR>
											) : (
												conciliacoes.map((c) => {
													if (c.date === dl)
														return (
															<ConciliacaoTR
																conc={c}
																getExtratos={getExtratos}
															/>
														);
													return null;
												})
											)}
										</S.TBody>
									</S.Table>
								</S.TableContainer>
							</div>
						))
					)}
					<div style={{ height: 25 }} />
				</S.ConciliacoesContainer>
			</S.Body>
		</S.Container>
	);
}

function ConciliacaoTR({
	conc,
	getExtratos,
}: {
	conc: ConciliacaoProps;
	getExtratos(tipo: string, conciliacao: any, setLoading: any): void;
}) {
	const [loadingXML, setLoadingXML] = useState(false);
	const [loadingDebito, setLoadingDebito] = useState(false);
	const [loadingCredito, setLoadingCredito] = useState(false);
	const [loadingCHARGEBACK, setLoadingCHARGEBACK] = useState(false);

	return (
		<S.BodyTR>
			<td>{conc.conta.nome}</td>
			<td>{conc.trailler.CapturedTransactionsQuantity || '-'}</td>
			<td>{conc.trailler.CanceledTransactionsQuantity || '-'}</td>
			<td>{conc.trailler.PaidInstallmentsQuantity || '-'}</td>
			<td>{conc.trailler.ChargebacksQuantity || '-'}</td>
			<td>
				<div className='td_grupo '>
					<button
						type='button'
						onClick={(e) => {
							e.preventDefault();
							getExtratos('XML', conc, setLoadingXML);
						}}
						/*href={
							'/admin/conciliacao/extratos?' +
							qs.stringify(
								Object.assign(
									{ formato: 'XML' },
									{
										ref: conciliacao.ref,
										conta_id: conciliacao.conta.id,
									}
								)
							)
						}
						*/
					>
						{loadingXML ? (
							<img className='loadingImg' src={loadingGif} alt='loading' />
						) : (
							'XML'
						)}
					</button>
					{conc.conta.codigo !== '274319774' && (
						<button
							onClick={(e) => {
								e.preventDefault();
								getExtratos('EEVD', conc, setLoadingDebito);
							}}
							/*href={
								'/admin/conciliacao/extratos?' +
								qs.stringify(
									Object.assign(
										{ formato: 'EEVD' },
										{
											ref: conciliacao.ref,
											conta_id: conciliacao.conta.id,
										}
									)
								)
							}*/
						>
							{loadingDebito ? (
								<img className='loadingImg' src={loadingGif} alt='loading' />
							) : (
								'Débito'
							)}
						</button>
					)}
					<button
						onClick={(e) => {
							e.preventDefault();
							getExtratos('EEVC', conc, setLoadingCredito);
						}}
						/*href={
							'/admin/conciliacao/extratos?' +
							qs.stringify(
								Object.assign(
									{ formato: 'EEVC' },
									{
										ref: conciliacao.ref,
										conta_id: conciliacao.conta.id,
									}
								)
							)
						}*/
					>
						{loadingCredito ? (
							<img className='loadingImg' src={loadingGif} alt='loading' />
						) : (
							'Crédito'
						)}
					</button>

					<button
						onClick={(e) => {
							e.preventDefault();
							getExtratos('CBK', conc, setLoadingCHARGEBACK);
						}}
						/*href={
							'/admin/conciliacao/extratos?' +
							qs.stringify(
								Object.assign(
									{ formato: 'XML' },
									{
										ref: conciliacao.ref,
										conta_id: conciliacao.conta.id,
									}
								)
							)
						}
						*/
					>
						{loadingCHARGEBACK ? (
							<img className='loadingImg' src={loadingGif} alt='loading' />
						) : (
							'Chargeback'
						)}
					</button>
				</div>
			</td>
		</S.BodyTR>
	);
}

// usar card modificado para as opcoes de cima
// Copiar modelo de dropdown do exportar
// input de pesquisa baseado no design original do bill
// table inspirada no bill
// lembrar de puxar modal de detalhes ja feito
